import { createSlice } from '@reduxjs/toolkit';
import { MANAGE_EMAIL } from '../../actions/ManageEmail/ManageEmailType';

const initialState = {
  manageEmail: {
    isLoading: false,
    // data: {
    data: null,
    errors: '',
    message: ''
  }
};

export const manageEmailSlice = createSlice({
  name: MANAGE_EMAIL,
  initialState,
  reducers: {
    SendEmail: (state, action) => {
        console.log('manage email')
      if (action.payload) {
        state.manageEmail.data = action.payload;
      }
      state.manageEmail.isLoading = false;
    },
    setManageEmailFailureAction: (state, action) => {
      state.manageEmployeeCycles.isLoading = false;
      state.manageEmployeeCycles.errors = action.payload;
    }
  }
});

export const { SendEmail, setManageEmailFailureAction } = manageEmailSlice.actions;

export default manageEmailSlice.reducer;
